import React from "react";
import { useUnit } from "effector-react";
import { useSearchParams } from "react-router-dom";
import StartPage from "./pages/StartPage/StartPage";
import { Container, MissingTotemId } from "./TotemLaundryStyles";
import FailedPayment from "./pages/FailedPayment/FailedPayment";
import ProcessingPayment from "./pages/ProcessingPayment/ProcessingPayment";
import SuccessPayment from "./pages/SuccessPayment/SuccessPayment";
import ChooseTax from "./pages/ChooseTax/ChooseTax";
import SendReceipt from "./pages/SendReceipt/SendReceipt";
import InactivityTimer from "./components/InactivityTimer/InactivityTimer";
import { setStation } from "../../stores/UserStore/UserStore";
import FailedActivation from "./pages/FailedActivation/FailedActivation";
import ChooseLaundryType from "./pages/ChooseLaundryType/ChooseLaundryType";
import ChooseLaundryMachine from "./pages/ChooseLaundryMachine/ChooseLaundryMachine";
import { PAGES } from "../../stores/LaundryStore/LaundryStore.types";
import LaundryPayment from "./pages/LaundryPayment/LaundryPayment";
import { LaundryStore, setTotemId } from "../../stores/LaundryStore/LaundryStore";

const pages = [
  StartPage, // 0
  ChooseLaundryType, // 1
  ChooseLaundryMachine, // 2
  LaundryPayment, // 3
  ProcessingPayment, // 4
  ChooseTax, // 5
  SendReceipt, // 6
  SuccessPayment, // 7
  FailedPayment, // 8
  FailedActivation, // 9
];

const TotemLaundry: React.FC = () => {
  const [searchParams] = useSearchParams();
  const totemId = searchParams.get("totemId") ?? "";
  const station = searchParams.get("station") ?? "";

  const { currPage } = useUnit(LaundryStore);

  React.useEffect(() => {
    setTotemId(totemId);
    setStation(station);
  }, [totemId, station]);

  const renderPage = () => {
    const PageComponent = pages[currPage];
    return <PageComponent />;
  };

  const renderTimer = () => {
    if (
      currPage === PAGES.CHOOSE_LAUNDRY_TYPE ||
      currPage === PAGES.CHOOSE_LAUNDRY_MACHINE ||
      currPage === PAGES.LAUNDRY_PAYMENT ||
      currPage === PAGES.SEND_RECEIPT
    )
      return <InactivityTimer timeout={300000} />;

    return <></>;
  };

  if (!totemId) {
    return <MissingTotemId>Preencha o totemId</MissingTotemId>;
  }

  return (
    <Container>
      {renderTimer()}
      {renderPage()}
      {/* <ConnectionKeepAlive totemId={totemId} /> */}
    </Container>
  );
};

export default TotemLaundry;
